import { BrowserModule } from '@angular/platform-browser';
import { NgxEchartsModule } from 'ngx-echarts';
import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SignInComponent } from './components/auth/sign-in/sign-in.component';
import { HomeComponent } from './components/dashboard/home/home.component';
import { AuthGuard } from './guard/auth.guard';
import { TiposOperacionesComponent } from './components/dashboard/tipos-operaciones/tipos-operaciones.component';
import { ConexionComponent } from './components/dialogs/crear/conexion/conexion.component';
import { EditarConexionComponent } from './components/dialogs/editar/editar-conexion/editar-conexion.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// DIALOGS
import { EditarCanalComponent } from './components/dialogs/editar/editar-canal/editar-canal.component';
import { EditarTipoOperacionComponent } from './components/dialogs/editar/editar-tipo-operacion/editar-tipo-operacion.component';
import { EditarTipoSakeComponent } from './components/dialogs/editar/editar-tipo-sake/editar-tipo-sake.component';
import { EditarUsuarioComponent } from './components/dialogs/editar/editar-usuario/editar-usuario.component';
import { EditarRolComponent } from './components/dialogs/editar/editar-rol/editar-rol.component';
import { DesicionComponent } from './components/dialogs/desicion/desicion.component';
import { CanalComponent } from './components/dialogs/crear/canal/canal.component';
import { RolComponent } from './components/dialogs/crear/rol/rol.component';
import { TipoOperacionComponent } from './components/dialogs/crear/tipo-operacion/tipo-operacion.component';
import { TipoSakeComponent } from './components/dialogs/crear/tipo-sake/tipo-sake.component';
import { UsuarioComponent } from './components/dialogs/crear/usuario/usuario.component';
import { CrearGruposComponent } from './components/dialogs/crear/crear-grupos/crear-grupos.component';
import { EditarGruposComponent } from './components/dialogs/editar/editar-grupos/editar-grupos.component';
import { CrearCuentasComponent } from './components/dialogs/crear/crear-cuentas/crear-cuentas.component';
import { EditarCuentasComponent } from './components/dialogs/editar/editar-cuentas/editar-cuentas.component';
import { CrearSakeComponent } from './components/dialogs/crear/crear-sake/crear-sake.component';
import { EditarSakeComponent } from './components/dialogs/editar/editar-sake/editar-sake.component';
import { CrearOperacionComponent } from './components/dialogs/crear/crear-operacion/crear-operacion.component';
import { EditarOperacionComponent } from './components/dialogs/editar/editar-operacion/editar-operacion.component';
import { CrearOperacionCuentaComponent } from './components/dialogs/crear/crear-operacion-cuenta/crear-operacion-cuenta.component';
import { EditarOperacionCuentaComponent } from './components/dialogs/editar/editar-operacion-cuenta/editar-operacion-cuenta.component';
import { CargarOperacionesComponent } from './components/dialogs/cargar-operaciones/cargar-operaciones.component';
import { MascaraMontosPipe } from './pipes/mascara_montos.pipe';
import {
  CommonModule,
  HashLocationStrategy,
  LocationStrategy,
} from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CredentialsAdComponent } from './components/dialogs/credentials-ad/credentials-ad.component';
import { SharedModule } from './components/shared/shared.module';
import { MaterialModule } from './material.module';
import localeEs from '@angular/common/locales/es';
import { registerLocaleData } from '@angular/common';
import { FullTextSearchComponent } from './components/dashboard/full-text-search/full-text-search.component';
import { TextSearchFilterComponent } from './components/dashboard/full-text-search/text-search-filter/text-search-filter.component';
import { CardTextSearchComponent } from './components/dashboard/full-text-search/card-text-search/card-text-search.component';
import { CoreModule } from './core/core.module';
import { GuidedTourModule } from './shared/guided-tour/guided-tour.module';
import { TokenInterceptor } from './core/interceptors/headers-interceptor';
import { CasosModule } from './components/casos/casos.module';
import { GraphSearchComponent } from './components/dashboard/graph-search/graph-search.component';
import { GraphComponent } from './components/dashboard/graph-search/graph/graph.component';
import * as echarts from 'echarts';
import { Status_taskPipe } from './pipes/status_task.pipe';
import { GDialogComponent } from './components/dashboard/graph-search/graph/gdialog.component';
import { ForceGraphComponent } from './components/dashboard/graph-search/3d-force-graph/3d-force-graph.component';
import { HeaderGraphComponent } from './components/dashboard/graph-search/header/header.component';
import { TableGraphComponent } from './components/dashboard/graph-search/table-search/table-search.component';
import { CreateSearchDialogComponent } from './components/dashboard/graph-search/create-search-dialog/create-search-dialog.component';
import { ModalImportComponent } from './components/dashboard/graph-search/neovis-graph/modal-import/modal-import.component';
import { ChannelsandoperationsComponent } from './components/dashboard/channelsandoperations/channelsandoperations.component';
import { TextSearchRasComponent } from './components/dashboard/text-search-ras/text-search-ras.component';
import { HeaderRasSearchComponent } from './components/dashboard/text-search-ras/header-ras-search/header-ras-search.component';
import { SearchRasContentComponent } from './components/dashboard/text-search-ras/search-ras-content/search-ras-content.component';
import { FilterTextRasComponent } from './components/dashboard/text-search-ras/header-ras-search/filter-text-ras/filter-text-ras.component';
import { DescriptionModalRasComponent } from './components/dashboard/text-search-ras/search-ras-content/description-modal-ras/description-modal-ras.component';
import { AuditoryComponent } from './modules/auditory/main/auditory.component';
registerLocaleData(localeEs, 'es');
import { EnvServiceProvider } from 'src/app/services/env.service.provider';
import { ForskerComponent } from './components/dashboard/forsker/forsker.component';
import { LogCasesComponent } from './modules/auditory/log-cases/log-cases.component';
import { FilterLogCasesComponent } from './modules/auditory/log-cases/filter-log-cases/filter-log-cases.component';
import { FilterLogComponent } from './modules/auditory/main/filter-log/filter-log.component';
import { MainReportsResumeComponent } from './modules/reportResume/main-reports-resume/main-reports-resume.component';
import { GeneralReportResumeComponent } from './modules/reportResume/main-reports-resume/general-report-resume/general-report-resume.component';
import { UnitReportResumeComponent } from './modules/reportResume/main-reports-resume/unit-report-resume/unit-report-resume.component';
import { UserReportResumeComponent } from './modules/reportResume/main-reports-resume/user-report-resume/user-report-resume.component';
import { CaseTypeReportResumeComponent } from './modules/reportResume/main-reports-resume/case-type-report-resume/case-type-report-resume.component';
import { MallaModalDetalleComponent } from './components/malla/malla-modal-detalle/malla-modal-detalle.component';
import { GestionApisComponent } from './gestion-apis/gestion-apis.component';
import { TimerManagementComponent } from './modules/timer-management/timer-management.component';
import { CreateTimerComponent } from './modules/timer-management/create-timer/create-timer.component';
import { MarkdownModule } from 'ngx-markdown';

@NgModule({
  declarations: [
    AppComponent,
    SignInComponent,
    HomeComponent,
    ChannelsandoperationsComponent,
    EditarCanalComponent,
    EditarTipoOperacionComponent,
    EditarTipoSakeComponent,
    EditarUsuarioComponent,
    EditarRolComponent,
    DesicionComponent,
    CanalComponent,
    RolComponent,
    TipoOperacionComponent,
    TipoSakeComponent,
    UsuarioComponent,
    ConexionComponent,
    EditarConexionComponent,
    TiposOperacionesComponent,
    CrearGruposComponent,
    EditarGruposComponent,
    CrearCuentasComponent,
    EditarCuentasComponent,
    CrearSakeComponent,
    EditarSakeComponent,
    CrearOperacionComponent,
    EditarOperacionComponent,
    CrearOperacionCuentaComponent,
    EditarOperacionCuentaComponent,
    CargarOperacionesComponent,
    MascaraMontosPipe,
    Status_taskPipe,
    CredentialsAdComponent,
    FullTextSearchComponent,
    TextSearchFilterComponent,
    CardTextSearchComponent,
    GraphSearchComponent,
    GraphComponent,
    GDialogComponent,
    ForceGraphComponent,
    HeaderGraphComponent,
    TableGraphComponent,
    CreateSearchDialogComponent,
    ModalImportComponent,
    TextSearchRasComponent,
    HeaderRasSearchComponent,
    SearchRasContentComponent,
    FilterTextRasComponent,
    DescriptionModalRasComponent,
    AuditoryComponent,
    ForskerComponent,
    LogCasesComponent,
    FilterLogCasesComponent,
    FilterLogComponent,
    MainReportsResumeComponent,
    GeneralReportResumeComponent,
    UnitReportResumeComponent,
    UserReportResumeComponent,
    CaseTypeReportResumeComponent,
    MallaModalDetalleComponent,
    GestionApisComponent,
    TimerManagementComponent,
    CreateTimerComponent,
  ],
  imports: [
    BrowserModule,
    CommonModule,
    CoreModule,
    AppRoutingModule,
    MatProgressSpinnerModule,
    ReactiveFormsModule,
    SharedModule,
    FormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    MaterialModule,
    CasosModule,
    NgxEchartsModule.forRoot({
      echarts,
    }),
    MarkdownModule.forRoot(),
    GuidedTourModule,
  ],
  entryComponents: [
    EditarCanalComponent,
    EditarTipoOperacionComponent,
    EditarTipoSakeComponent,
    EditarUsuarioComponent,
    EditarRolComponent,
    DesicionComponent,
    CanalComponent,
    RolComponent,
    TipoOperacionComponent,
    TipoSakeComponent,
    UsuarioComponent,
    EditarCuentasComponent,
    CrearCuentasComponent,
    GDialogComponent,
    ModalImportComponent,
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'es' },
    AuthGuard,
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    EnvServiceProvider,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
